// SASTAVNICA UTILS

import { app_build_version_id } from "..";
import config from "../utils/config";
import { csv_utils_array_to_csv_row } from "../utils/frfr-csv-utils";
import { _detect_bomlevel_on_graphlevel, _detect_graphlevel } from "../utils/frfr-bomlevel-utils";
import { NEW_LINE } from "../utils/frfr-string-consts";
import { sastavnica_csv_keys_sr, sastavnica_excel_key_to_internal_key_translations, sastavnica_external_columns_full, sastavnica_excel_sorted_keys, sastavnica_external_sorted_keys, sastavnica_internal_key_to_excel_key_translations, sastavnica_internal_sorted_keys } from "./ter-sastavnica-columns-lib";
import { sha256 } from "js-sha256";
import { js_utils } from "../utils/frfr-js-utils";
import tclocal from "./ter-consts-local-lib";


export const sastavnica_aoa_header_row_make = () => {
  const sastavnica_aoa_header_row = [...sastavnica_external_sorted_keys];
  return sastavnica_aoa_header_row;
};


export const sastavnica_internal_header_row_make = () => {
  let sastavnica_internal_header_row = {};
  sastavnica_internal_sorted_keys.forEach((key) => {
    sastavnica_internal_header_row[key] = key;
  });
  return sastavnica_internal_header_row;
};


export const convert_sastavnica_external_to_sastavnica_array_of_arrays = (sastavnica_external_rows) => {
  // TODO ++++RAD U TOKU
  let aoa_rows = [];
  sastavnica_external_rows.forEach((row) => {
    let converted_row = []; // single row ARRAY
    const sorted_keys = sastavnica_excel_sorted_keys; // lista keyeva iz definicija sa eksternog api-ja za uvoz excel fajlova
    sorted_keys.forEach((key, index) => {
      // rucno pushujemo u row array
      converted_row.push(row[key]);
    });
    aoa_rows.push(converted_row);
  });
  return aoa_rows;
};


const _spakujObjekatUCsvRow = (obj) => {
  const keys_sorted = sastavnica_external_sorted_keys;
  let itemsForCsvArr = [];
  keys_sorted.forEach((key) => {
    let item = '';
    if (typeof obj[key] === 'undefined' || obj[key] === null) {
      item = '';
    } else {
      item = obj[key];
    }
    itemsForCsvArr.push(item);
  });
  return csv_utils_array_to_csv_row(itemsForCsvArr);
};
export const _convert_sastavnica_internal_to_sastavnica_csv_export_temp1 = (sastavnica_internal) => {
  let emptyRow = NEW_LINE;
  let kompletniCsv = '';
  let csvHeader = sastavnica_csv_keys_sr + NEW_LINE;
  kompletniCsv += csvHeader;
  // let _rows = [];
  if (Array.isArray(sastavnica_internal)) {
    let _csvPart = ''; //
    sastavnica_internal.forEach(internal_row => {
      // each row
      let row_obj = {};
      sastavnica_external_sorted_keys.forEach((keyTemp, index) => {
        // each field
        let key = sastavnica_external_sorted_keys[index];
        let field_value = internal_row[keyTemp];
        row_obj[key] = field_value;
      });
      _csvPart += _spakujObjekatUCsvRow(row_obj);
      // _rows.push(row_obj);
    });
    kompletniCsv += _csvPart;
  }
  // csv finalizacija
  kompletniCsv += emptyRow;
  return kompletniCsv;
};


export const _make_sastavnica_for_ext_api_export = (sastavnica_internal, company_orderkey, company_orderitemnumber, virbom_rev_id, beleskaUzExport = '', user_id = '?', virbom_created_datetime) => {
  let _rows = [];
  if (Array.isArray(sastavnica_internal)) {
    sastavnica_internal.forEach(internal_row => {
      // each row
      let row_obj = {};
      sastavnica_excel_sorted_keys.forEach((excelKey, index) => {
        let internalKey = sastavnica_excel_key_to_internal_key_translations[excelKey];
        let field_value = internal_row[internalKey];
        row_obj[excelKey] = field_value;
      });
      _rows.push(row_obj);
    });
  }
  //
  const config_detected_env = config.detected_env; // LOCALHOST_DEV/DEV/STG/PROD
  const current_time_utc = new Date().toISOString();
  // const authorExportMeta = 'env/' + config_detected_env + ',' + 'appversion/' + app_build_version_id + ',' + 'datetime/' + current_time_utc + ',' + 'user/' + user_id;
  const authorExportMeta = 'appname/SASTAVLJAC' + ',' + 'env/' + config_detected_env + ',' + 'appversion/' + app_build_version_id + ',' + 'datetime/' + current_time_utc + ',' + 'user/' + user_id;
  //
  // name: 'NemaNazivFajla.xlsx',
  let name = 'NeimenovanExportIzSastavljaca.xlsx';
  if (typeof virbom_created_datetime === 'string' && virbom_created_datetime !== '') {
    // 2024-01-22T13:06:26.000Z
    // TODO
    try {
      // date_utils.frfrdatetimestring_to_frfrdatetimeobj
      name = 'ExportIzSastavljaca' + current_time_utc.slice(0, 16).replaceAll(':', '-') + '.xlsx';
    } catch (error) {
      console.log(error);
    }
  }
  return {
    readme: 'Ovo je eksport sastavnice iz aplikacije SASTAVLJAČ na MES API...',
    acKey: company_orderkey, // company id narudzbe company_orderkey
    anNo: company_orderitemnumber, // company redni broj stavke narudzbe
    // id: company_filekey, // id fajle je postojao samo pri importu prvobitne sastavnice i on je sacuvan u company company_filekey ali nije potreban jer on identifikuje samo taj fajl koji vise nije potreban
    // name: 'NemaNazivFajla.xlsx',
    name: name,
    authorBomRevId: virbom_rev_id,
    authorExportMeta: authorExportMeta, // privremeno iskljuceno dok ne dodaju to u MES
    authorExportNote: beleskaUzExport,
    sheets: [
      {
        columns: sastavnica_external_columns_full,
        rows: _rows,
        name: "BOM summary"
      }
    ],
    meta: {
      readme1: 'Za sada columns sadrze definiciju kolona kako sam cuo na jednom sastanku da treba, a rows sadrzi array gde je jedan red jeadn objekat sa propertijima identicnim kao columns. id je id stavke ordera. Iako cemo koristii samo jedan Sheet mislim da je dobro da Sheets ipak bude array jer mi reprezentujemo excell fajl koji moze da ima vise Sheets.',
      readme2: 'authorBomRevId je jedinstveni broj koji je ključ po kojem se ova revizija razlikuje od svih ostalih i dodeljena je u aplikaciji u kojoj je autor izmena izvrsio izmene',
      readme3: 'authorExportNote je kratka beleska u kojoj autor koji vrsi eksport moze da upise neke napomene uz eksport.',
      beleske: 'Ne bi bilo lose da se uz svaki upload sastavnice moze da upise nekakva beleska, napomena ili sl. Ili ceo properti meta da ostaje netaknut kako bi cuvao bilo kakve pratece podatke uz jedan export kao ovo na primer.'
    }
  };
};


export const get_sastavnica_imported_index_by_key = (key) => {
  let index = 1;
  sastavnica_external_sorted_keys.forEach((item, i) => {
    if (item === key) {
      index = i;
    }
  });
  return index;
};


export const get_value_from_sastavnica_imported_row_arr = (row, key) => {
  const index = get_sastavnica_imported_index_by_key(key);
  const value = row[index];
  return value;
};


//
const _enrich_sastavnica_element_with_Digest = (sastavnica_row_obj) => {
  //
  let values_for_digest_arr = [];
  values_for_digest_arr.push(sastavnica_row_obj["Tip"]);
  const par_prefix = "Par";
  for (let i = 1; i < 31; i++) {
    const par_key = par_prefix + i;
    const par_val = sastavnica_row_obj[par_key];
    let prepared_par_val = null; // null is default
    if (typeof par_val === 'string' || par_val < 0 || par_val === 0 || par_val > 0) {
      // if (js_utils.is_number(par_val) || typeof par_val === 'string') {
      // prepared_par_val = par_val;
      prepared_par_val = ("" + par_val); // konvertujemo svako Par polje u string
    }
    values_for_digest_arr.push(prepared_par_val);
  }
  values_for_digest_arr.push(sastavnica_row_obj["Materijal"]);
  //
  const json = JSON.stringify(values_for_digest_arr);
  const sha256_digest = sha256(json);
  return {
    ...sastavnica_row_obj,
    Digest: sha256_digest
  };
};


export const _spakuj_objekat_u_sastavnica_internal_row_arr = (obj) => {
  // obj je jedan red sastavnice i pakujemo ga takodje kao OBJECT koji ide za svaki red sastavnice
  let sastavnica_row_obj = {};
  sastavnica_internal_sorted_keys.forEach((key) => {
    let item = null;
    /*
    if (typeof obj[key] === 'undefined' || obj[key] === null) {
      // TODO: mozda je bolje da proveravamo da je typeof number ili string a sve ostalo da bude null.
      item = null;
    } else {
      item = obj[key];
    }
    */
    const val = obj[key];
    if (val === true) {
      item = tclocal.SASINT_YES; // true converted to string
    } else if (val === false) {
      item = tclocal.SASINT_NO; // false converted to string
    } else {
      if (typeof val === 'string' || js_utils.is_number(val)) {
        item = val;
      } else {
        // sve osim string ili number u sastavnici stavljamo kao null
        item = null;
      }
    }
    sastavnica_row_obj[key] = item; // svaki internal key postaje property objekta
  });
  let enriched_sastavnica_row_obj = sastavnica_row_obj;
  if (sastavnica_row_obj.Kat !== "M") {
    // Digest dodajemo samo za elemente koji nisu Kategorija "M"
    enriched_sastavnica_row_obj = _enrich_sastavnica_element_with_Digest(sastavnica_row_obj);
  }
  return enriched_sastavnica_row_obj;
};


export const _prosiri_sastavnica_internal_sa_info_api_podacima = (sastavnica_internal, info_api_arr) => {
  // TODO...
  const _prosirena_sastavnica_internal = sastavnica_internal.map((item, index) => {
    // TODO ovde treba da kombinujemo pdoatke sa API-ja na osnovu reda sastavnice u kojem smo...
    return item;
  });
  return _prosirena_sastavnica_internal;
};


export const read_value_as_string = (val) => {
  let _str = null;
  if (typeof val === 'number') {
    _str = val.toString();
  } else if (typeof val === 'string') {
    _str = val;
  }
  return _str;
};
export const read_value_as_integer = (val) => {
  let _int = null;
  if (typeof val === 'number') {
    _int = val;
  } else if (typeof val === 'string') {
    _int = Number.parseInt(val);
  }
  return _int;
};
export const read_value_as_float = (val) => {
  let _float = null;
  if (typeof val === 'number') {
    _float = val;
  } else if (typeof val === 'string') {
    _float = Number.parseFloat(val);
  }
  return _float;
};


//
export const _get_ident_nadredjenog_from_sastavnica_internal = (sastavnicaInternal, _nivo) => {
  // _ident_nadredjenog i _ident_modula
  // console.log('*** _get_ident_nadredjenog _nivo', _nivo, 'sastavnicaInternal', sastavnicaInternal);
  let _ident_nadredjenog = '';
  let _ident_komore = '';
  let _ident_modula = '';
  //
  const graphlevel = _detect_graphlevel(_nivo);
  let target_bomlevel;
  if (graphlevel === 2) {
    //
    // Iznad je samo 1 nivo. Proveravamo da li je to klima komora ili modul?
    target_bomlevel = _detect_bomlevel_on_graphlevel(_nivo, 1);
    let exit = false;
    let i = 0;
    while (exit === false) {
      const row_obj = sastavnicaInternal[i];
      if (row_obj) {
        console.log('*** grpahlevel 2 - row_obj', row_obj);
        if (row_obj.Nivo === target_bomlevel) {
          if (row_obj.virtelclass === 'terkk$klimakomora') {
            _ident_komore = row_obj.Ident;
            _ident_nadredjenog = _ident_komore;
          } else if (row_obj.virtelclass === 'terkk$modul') {
            _ident_modula = row_obj.Ident;
            _ident_nadredjenog = _ident_modula;
          }
          exit = true;
        }
        i++;
      } else {
        exit = true;
      }
    } // end of while
  } else if (graphlevel > 2) {
    //
    // Proveravamo da li je na nivo 2 modul?
    let _pronadjen_modul_na_level_2 = false;
    target_bomlevel = _detect_bomlevel_on_graphlevel(_nivo, 2);
    let exit = false;
    let i = 0;
    while (exit === false) {
      const row_obj = sastavnicaInternal[i];
      if (row_obj) {
        if (row_obj.Nivo === target_bomlevel && row_obj.virtelclass === 'terkk$modul') {
          _ident_modula = row_obj.Ident;
          _ident_nadredjenog = _ident_modula;
          _pronadjen_modul_na_level_2 = true;
          exit = true;
        }
        i++;
      } else {
        exit = true;
      }
    } // end of while
    //
    if (_pronadjen_modul_na_level_2 === false) {
      //
      // Sada proveravamo da li je na nivo 1 klima komora ili modul?
      target_bomlevel = _detect_bomlevel_on_graphlevel(_nivo, 1);
      let exit = false;
      let i = 0;
      while (exit === false) {
        const row_obj = sastavnicaInternal[i];
        if (row_obj) {
          if (row_obj.Nivo === target_bomlevel) {
            if (row_obj.virtelclass === 'terkk$klimakomora') {
              _ident_komore = row_obj.Ident;
              _ident_nadredjenog = _ident_komore;
            } else if (row_obj.virtelclass === 'terkk$modul') {
              _ident_modula = row_obj.Ident;
              _ident_nadredjenog = _ident_modula;
            }
            exit = true;
          }
          i++;
        } else {
          exit = true;
        }
      } // end of while
    }
  }
  //
  return [_ident_nadredjenog, _ident_modula];
};


// OLD
const OLD_csvHeader2 = `Nivo sastavnice,Kategorija,Radna Stanica,Grupa,Ident,Naziv,Operacije,Radni centar-Resurs,Br.Izvrsilaca,Pripremno vreme,Vreme operacije,Tip,Kol,JM,Mat 1,Mat 2,Mat 3,Duzina,Sirina,Visina,Ger Levi,Ger Desni,X1,Y1,AX1,BY1,X2,Y2,AX2,BY2,MASA`;
// const csvHeader2_Skraceno = `Nivo,Kat,RS,Gr,Ident,Naziv,Operacije,Radni centar-Resurs,BrIZ,PV,VO,Tip,Kol,JM,Mat 1,Mat 2,Mat 3,Duzina,Sirina,Visina,GL,GD,X1,Y1,AX1,BY1,X2,Y2,AX2,BY2,MASA`;

/*
let row1 = [
  Nivo 1,Nivo 2,Nivo 3,Nivo 4,Nivo 5,Tip,RS,IDENT,NAZIV IDENTA,Norm,JM,Duzina Profila [mm],Ger Levi,Ger Desni,Razvijena Duzina Lima,Razvijena ?irina Lima,Du?ina ?kart Lima,?irina ?kart Lima,Du?ina Ispune,?irina Ispune
]
*/
